const en = {
  i18nView: {
    login: 'Login',
    account: 'Account'
  }
};

export default en;